import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  quizAlertModal: false,
  countryLanguageModal: false,
  countryLanguageDeleteModal: false,
  employeePdfAddModal: false,
  employeePdfEditModal: false,
  actioncardsSetEditModal: false,
  selectedEmployeePdf: null,
};

const modalSlice = createSlice({
  name: "modal",
  initialState,
  reducers: {
    setQuizAlertModal(state, action) {
      state.quizAlertModal = action.payload;
    },

    setCountryLanguageModal(state, action) {
      state.countryLanguageModal = action.payload;
    },

    setCountryLanguageDeleteModal(state, action) {
      state.countryLanguageDeleteModal = action.payload;
    },

    setEmployeePdfAddModal(state, action) {
      state.employeePdfAddModal = action.payload;
    },

    setEmployeePdfEditModal(state, action) {
      state.employeePdfEditModal = action.payload;
    },

    setActioncardsSetEditModal(state, action) {
      state.actioncardsSetEditModal = action.payload;
    },

    setSelectedEmployeePdf(state, action) {
      state.selectedEmployeePdf = action.payload;
    },

    clearSelectedState(state) {
      state.quizAlertModal = false;
      state.countryLanguageModal = false;
      state.countryLanguageDeleteModal = false;
      state.employeePdfAddModal = false;
      state.employeePdfEditModal = false;
      state.actioncardsSetEditModal = false;
      state.selectedEmployeePdf = null;
    },
  },
});

export const {
  setQuizAlertModal,
  setCountryLanguageModal,
  setCountryLanguageDeleteModal,
  setEmployeePdfAddModal,
  setEmployeePdfEditModal,
  setActioncardsSetEditModal,
  setSelectedEmployeePdf,
  clearSelectedState,
} = modalSlice.actions;

export default modalSlice.reducer;
